<punches-nav></punches-nav>

<div class="punch-history-wrapper">
  <div class="page-shell">
    <div class="page-header">
      <div class="title-group">
        <h2>Punch History</h2>
        <p>Search and review clock activity.</p>
      </div>
    </div>

    <div class="toolbar-card">
      <div class="search-row">
        <div class="search-wrap">
          <input type="text" [(ngModel)]="searchTerm" placeholder="Search employee, RFID, or device..."
            (keyup.enter)="onSearch()" />
        </div>

        <div class="search-actions">
          <button type="button" class="btn btn-ghost" (click)="clearSearch()" [disabled]="!searchTerm.trim()">
            Clear
          </button>

          <button type="button" class="btn btn-primary" (click)="onSearch()">
            Search
          </button>
        </div>
      </div>

      <div class="toolbar-meta" *ngIf="!isLoading">
        <div class="results-meta">
          <span>{{ totalCount }} records</span>
          <span>Page {{ currentPage }} of {{ totalPages }}</span>
        </div>

        <div class="toolbar-actions">
          <div class="page-size">
            <label for="pageSize">Show</label>
            <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize()">
              <option *ngFor="let size of pageSizeOptions" [value]="size">
                {{ size }}
              </option>
            </select>
          </div>

          <div class="pager">
            <button type="button" (click)="prevPage()" [disabled]="currentPage === 1">
              Prev
            </button>
            <button type="button" (click)="nextPage()" [disabled]="currentPage === totalPages">
              Next
            </button>
          </div>

          <button type="button" class="btn btn-primary" (click)="exportToExcel()"
            [disabled]="isLoading || isExporting || totalCount === 0">
            {{ isExporting ? 'Exporting...' : 'Export Excel' }}
          </button>
        </div>
      </div>
    </div>

    <div class="list-shell">
      <div *ngIf="isLoading" class="loading-state">
        <div class="spinner"></div>
      </div>

      <div class="error-state" *ngIf="!isLoading && errorMessage">
        {{ errorMessage }}
      </div>

      <div class="empty-state" *ngIf="!isLoading && !errorMessage && punchLogs.length === 0">
        No punch history found.
      </div>

      <div class="punch-list" *ngIf="!isLoading && !errorMessage && punchLogs.length > 0">
        <div class="punch-row" *ngFor="let log of punchLogs; trackBy: trackByLogId"
          [class.expanded]="isExpanded(log.id)" [class.has-violation]="hasViolation(log)"
          (click)="toggleExpanded(log.id)">
          <div class="row-summary">
            <div class="main-info">
              <div class="top-line">
                <span class="name">{{ getUserFullName(log) }}</span>
                <span class="log-pill" [ngClass]="getLogTypeClass(log)">
                  {{ getLogTypeLabel(log) }}
                </span>
              </div>

              <div class="sub-line">
                <span>RFID {{ log.user?.rfid || '—' }}</span>
                <span>•</span>
                <span>{{ getClockDeviceName(log) }}</span>
              </div>
            </div>

            <div class="time-info">
              <div class="time">{{ formatLogTime(log.logTime) }}</div>
              <div class="date">{{ formatLogDate(log.logTime) }}</div>
            </div>
          </div>

          <div class="row-details" *ngIf="isExpanded(log.id)" (click)="$event.stopPropagation()">
            <div class="details-grid">
              <div class="detail-item">
                <span class="label">Log ID</span>
                <span class="value">{{ log.id }}</span>
              </div>

              <div class="detail-item">
                <span class="label">Violation</span>
                <span class="value">{{ getViolationText(log) }}</span>
              </div>

              <div class="detail-item">
                <span class="label">Updated By</span>
                <span class="value">{{ getUpdatedByName(log) }}</span>
              </div>

              <div class="detail-item">
                <span class="label">Updated At</span>
                <span class="value">{{ formatLogDateTime(log.updatedAt) }}</span>
              </div>

              <div class="detail-item detail-item-wide">
                <span class="label">Full Timestamp</span>
                <span class="value">
                  {{ formatLogFullTimestamp(log.logTime) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-bottombar" *ngIf="!isLoading && !errorMessage && punchLogs.length > 0">
      <div class="results-meta">
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
      </div>

      <div class="pager">
        <button type="button" (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
        <button type="button" (click)="nextPage()" [disabled]="currentPage === totalPages">
          Next
        </button>
      </div>
    </div>
  </div>
</div>